import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';

const UserCustomPkg = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    destination: '',
    paxNumber: '',
    checkinDate: null,
    checkoutDate: null,
    message: '',
  });
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckinDateChange = (date) => {
    setFormData({ ...formData, checkinDate: date });
  };

  const handleCheckoutDateChange = (date) => {
    setFormData({ ...formData, checkoutDate: date });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send the form data to the server using Axios
    axios
      .post('https://journey-scape-main.vercel.app/api/send-email2', formData)
      .then((response) => {
        console.log(response.data); // Server response
        if (response.data.message === 'Email sent successfully!') {
          // Handle success here
          setSuccessMessage('Form submitted! You will receive an email with your details.');
        } else {
          // Handle error here
          setSuccessMessage('Error sending the form data. Please try again later.');
        }
      })
      .catch((error) => {
        console.error('Error sending the form data:', error);
        // Handle error here
        setSuccessMessage('Error submitting the form. Please try again later.');
      });
  };

  return (
    <div className="trip-search-section shape-search-section">
      <div className="slider-shape" />
      <div className="container">
        <div className="trip-search-inner white-bg d-flex">
          <div className="input-group">
            <label>Name*</label>
            <input
              type="text"
              name="name"
              placeholder="Name"
              onChange={handleInputChange}
              value={formData.name}
            />
          </div>
          <div className="input-group">
            <label>Email*</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleInputChange}
              value={formData.email}
            />
          </div>
          <div className="input-group">
            <label>Destination*</label>
            <select
              name="destination"
              onChange={handleInputChange}
              value={formData.destination}
            >
              <option value="">Select Destination</option>
              <option value="Punjab">Punjab</option>
              <option value="Sindh">Sindh</option>
              <option value="Kpk">Kpk</option>
              <option value="Balochistan">Balochistan</option>
              <option value="Azad Kashmir">Azad Kashmir</option>
              <option value="Gilgit Baltistan">Gilgit Baltistan</option>
            </select>
          </div>
          <div className="input-group">
            <label>Pax Number*</label>
            <input
              type="number"
              name="paxNumber"
              placeholder="No.of People"
              onChange={handleInputChange}
              value={formData.paxNumber}
            />
          </div>
          <div className="input-group width-col-3">
            <label>Check-in Date*</label>
            <i className="far fa-calendar"></i>
            <DatePicker
              className="input-date-picker"
              placeholderText="MM / DD / YY"
              autoComplete="off"
              dateFormat="MM / dd / yy"
              selected={formData.checkinDate}
              onChange={handleCheckinDateChange}
              popperPlacement="bottom-start"
            />
          </div>
          <div className="input-group width-col-3">
            <label>Check-out Date*</label>
            <i className="far fa-calendar"></i>
            <DatePicker
              className="input-date-picker"
              placeholderText="MM / DD / YY"
              autoComplete="off"
              dateFormat="MM / dd / yy"
              selected={formData.checkoutDate}
              onChange={handleCheckoutDateChange}
              popperPlacement="bottom-start"
            />
          </div>
          <div className="input-group">
            <label>Message</label>
            <textarea
              name="message"
              placeholder="Enter your message here"
              onChange={handleInputChange}
              value={formData.message}
              style={{ minHeight: '0px' }}
            />
          </div>
          <div className="input-group width-col-3">
            <label className="screen-reader-text">Search</label>
            <input
              type="submit"
              name="travel-search"
              value="INQUIRE NOW"
              onClick={handleSubmit}
            />
          </div>
          {successMessage && <p>{successMessage}</p>}
        </div>
      </div>
    </div>
  );
};

export default UserCustomPkg;
